// extracted by mini-css-extract-plugin
export default {"content":"SignInPage_content__9TEWa","button":"SignInPage_button__GWDe8","input":"SignInPage_input__qRrfS","form":"SignInPage_form__7qk-U","label":"SignInPage_label__fZwLy"};